import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCart } from 'src/components/Cart/UseCart';
import { SummarySection } from '../SummarySection/SummarySection';
import { useTax } from '../useTax/useTax';

export const TaxSection: React.FC = () => {
  const { t } = useTranslation();
  const { isTaxSet, taxPrice } = useTax();
  const { checkout } = useCart();

  if (!isTaxSet) return null;

  return (
    <SummarySection
      subheading={t('order-summary.tax-heading')}
      price={t('order-summary.price', { price: taxPrice })}
      description={t('order-summary.tax-description', { price: checkout.subtotal })}
      data-test="tax"
    />
  );
};

TaxSection.displayName = 'TaxSection';
